import { MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { MachineCategory } from './core/models/entities/machine-category.type';

export class AppConstants {

    public static readonly MonitorWaitingTimeoutInSeconds = 5;
    public static readonly TIME_WITH_SECONDS_FMT = `hh:mm:ss`;
    public static readonly PLAYLIST_ITEM_DELIMITER = ':';
    public static readonly FILE_EXTENSION_DELIMITER = '.';
    public static readonly UNKNOWN_USER_AUTH_ERROR = 'unknown_user';
    public static readonly UNCONFIRMED_USER_AUTH_ERROR = 'unconfirmed_user';
    public static readonly DELETED_USER_AUTH_ERROR = 'deleted_user';
    public static readonly INVALID_CODE_AUTH_ERROR = 'invalid_code';
    public static readonly INVALID_CERTIFICATE_AUTH_ERROR = 'invalid_certificate';
    public static readonly PASSWORD_EXPIRED_AUTH_ERROR = 'password_expired';
    public static readonly ACCOUNT_CHANGED_ERROR = 'account changed';

    public static readonly PERMISSION_ERROR_MESSAGE = 'It seems you have not enough permission to perform this action.';
    public static readonly NOT_FOUND_PAGE_ERROR_MESSAGE = 'The page you are looking for might have been removed had its name changed or is temporarily unavailable.';

    public static readonly PASSWORD_NOT_MATCH_ERROR_MESSAGE = 'Entered password does not match the confirmation!';
    public static readonly CHANGING_PASSWORD_TITLE = 'Changing password';
    public static readonly CHANGING_PASSWORD_SUCCESS = 'Password successfully updated';
    public static readonly CHANGING_PASSWORD_ERROR = 'Password change failed';

    public static readonly INVALID_CREDENTIALS_MESSAGE = 'You have entered an invalid username or password';
    public static readonly INVALID_TWO_FACTOR_CODE_MESSAGE = 'You have entered an invalid authentication code';
    public static readonly UNCONFIRMED_ACCOUNT_MESSAGE = 'Your account wasn`t confirmed. Please check your email and confirm email address';
    public static readonly DELETED_ACCOUNT_MESSAGE = 'This account was deleted. You can contact your company`s administrator';
    public static readonly INVALID_CERTIFICATE_MESSAGE = 'Client certificate is not valid';
    public static readonly LEGAL_CONSENT_ERROR_MESSAGE = `The IT department requires your agreement to the organization's system usage policy before granting access`;

    public static readonly LOGIN_ERROR_MESSAGE = 'Some error occured during logging in';
    public static readonly QUERY_PARAM_RETURN_URL = 'returnUrl';
    public static readonly BAD_REQUEST_RESPONSE_STATUS = 400;
    public static readonly SUCCSESS_REQUEST_RESPONSE_STATUS = 200;

    public static readonly MAWI_HELP_PATH = 'https://help.monitorsanywhere.com';
    public static readonly MAWI_TROUBLESHOOTING_GUIDE_PATH = 'https://help.monitorsanywhere.com/portal/en/kb/articles/troubleshoot-error-some-server-error-occurred-try-to-login-later-when-login-in-to-mawi';
    public static readonly MAWI_HELP_MAIL = 'mailto:help@monitorsanywhere.com';

    public static readonly DDS_PAGE_TITLE = 'DDS Signage';
    public static readonly DDS_SIGN_IN_PAGE_TITLE = 'Sign in - DDS Signage';
    public static readonly DDS_HELP_PATH = 'https://help.ddsm.com.au';
    public static readonly DDS_SUPPORT_MAIL = 'support@ddsm.com.au';
    public static readonly DDS_SUPPORT_MAILTO = 'mailto:support@ddsm.com.au';
    public static readonly DDS_SUPPORT_PATH = 'https://support.ddsm.com.au';

    public static readonly RESET_PASSWORD_SUCCESS_MESSAGE = 'We`ve received your request for password reset. Please check your email and follow instructions';

    public static readonly ADMINISTRATOR_ROLE = 'Administrator';
    public static readonly EDITOR_ROLE = 'Editor';
    public static readonly PDF_ASSIGNER_ROLE = 'PDF Assigner';
    public static readonly CATEGORY_MANAGER_ROLE = 'Category Manager';

    public static readonly SELECTION_TYPE_ATTRIBUTE = 'selectionType';
    public static readonly SELECTION_AREA_CLASS_NAME = 'selection-area';
    public static readonly SELECTION_CLASS_NAME = 'selection';
    public static readonly PLAYLIST_ITEMS_SELECTION_CLASS_NAME = 'selection-playlist-items';
    public static readonly PLAYLIST_ITEMS_SELECTION_AREA_CLASS_NAME = 'items-selection-area';
    public static readonly PLAYLIST_ITEMS_BOUNDARY_CLASS_NAME = 'playlist-items-selection-boundary';

    public static readonly SERVER_PORT_STRING = 'serverPort';
    public static readonly SERVER_SSL_PORT_STRING = 'serverSslPort';
    public static readonly HTTPS_PROTOCOL = 'https';

    public static readonly DEFAULT_MONITOR_IMAGE_HEIGHT = 140;
    public static readonly DEFAULT_MONITOR_IMAGE_WIDTH = 220;
    public static readonly DEFAULT_ANDROID_DEVICE_IMAGE_HEIGHT = 120;
    public static readonly DEFAULT_ANDROID_DEVICE_IMAGE_WIDTH = 120;
    public static readonly FULL_SCREEN_MONITOR_IMAGE_HEIGHT = 700;
    public static readonly FULL_SCREEN_MONITOR_IMAGE_WIDTH = 1100;
    public static readonly FULL_SCREEN_LINK_MONITOR_IMAGE_HEIGHT = 1080;
    public static readonly FULL_SCREEN_LINK_MONITOR_IMAGE_WIDTH = 1920;

    public static readonly REMOTE_CONTROL_HEIGHT_TO_WIDTH_PROPRTION = 3 / 4;
    public static readonly REMOTE_CONTROL_MODAL_WINDOW_PADDING = 50;

    public static readonly CTRL_EVENT_KEY = 'Control';
    public static readonly SHIFT_EVENT_KEY = 'Shift';
    public static readonly Q_EVENT_KEY = 'q';

    public static readonly FULLY_DOWNLOADED_FILE = 100;
    public static readonly ZERO_DOWNLOADED_FILE = 0;
    public static readonly FILE_READER_SUCCESS_STATE = 2;
    public static readonly LOAD_START_EVENT = 'loadstart';
    public static readonly LOADED_METADATA_EVENT = 'loadedmetadata';
    public static readonly MULTIPLE_ITEMS_TITLE = 'Multiple items';
    public static readonly LOCAL_ITEM_TITLE = 'Local item';
    public static readonly EMPTY_URL_ITEM_TITLE = 'Empty url';
    public static readonly DEFAULT_PLAYLIST_ITEM_DURATION = '00:00:30';
    public static readonly MIN_PLAYLIST_ITEM_DURATION = '00:00:01';
    public static readonly DEFAULT_INNER_ITEM_DURATION = '00:01:00';
    public static readonly DEFAULT_PLAYLIST_ITEM_DURATION_IN_SECONDS = 30;
    public static readonly DEFAULT_DURATION_PICKER_TOOLTIP = 'Change playlist duration';
    public static readonly DEFAULT_PLAYLIST_ITEM_RSS_SPEED = 5;
    public static readonly ZERO_PLAYLIST_ITEM_RSS_SPEED = 0;
    public static readonly DEFAULT_PLAYLIST_ZOOM_LEVEL = 100;
    public static readonly PLAYLIST_MIN_DISPLAY_ZOOM_LEVEL = 0;
    public static readonly PLAYLIST_MIN_ZOOM_LEVEL = 10;
    public static readonly PLAYLIST_MAX_ZOOM_LEVEL = 1000;
    public static readonly PLAYLIST_ZOOM_LEVEL_STEP = 10;
    public static readonly ZERO_PDF_DELAY_INTERVAL = 0;
    public static readonly MIN_PDF_DELAY_INTERVAL = 1;
    public static readonly MAX_PDF_DELAY_INTERVAL = 60;
    public static readonly MIN_PDF_START_PAGE = 1;
    public static readonly ZERO_NUMBER = 0;

    public static readonly DEFAULT_MONITOR_MENU_HEIGHT = 490;
    public static readonly DEFAULT_MONITOR_INTERNAL_PADDING_WIDTH = 20;
    public static readonly FULL_MONITOR_KEY_DELIMITER = ':';
    public static readonly CLIENT_VERSION_TITLE_PREFIX = 'DDS Signage Server v';
    public static readonly CLIENT_TITLE = 'DDS Signage Server';
    public static readonly AUTH_DATA_NAME = 'authData';
    public static readonly ADB_OFFLINE_STATUS = 'offline';
    public static readonly ADB_ONLINE_STATUS = 'online';
    public static readonly ADB_DEVICE_ONLINE_STATUS_DESCRIPTION = 'device';
    public static readonly IS_NOTIFICATION_WINDOW_CLOSED = 'isLicenseNotificationWindowClosed';
    public static readonly NOTIFICATION_LAST_DATE_CLOSED = 'licenseNotificationLastDateClosed';
    public static readonly NOTIFICATION_SHOW_DATE = 'licenseNotificationShowDate';
    public static readonly PDF_PLAYLIST_START_DELAY = 3;
    public static readonly UPDATE_CLIENT_MACHINE_LIST_STORAGE_NAME = 'updateClientMachineList';
    public static readonly A_LETTER_KEY_CODE = 65;
    public static readonly ZIP_FILE_TYPE = 'zip';
    public static readonly TXT_FILE_TYPE = 'txt';
    public static readonly LIC_FILE_TYPE = 'lic';
    public static readonly AVI_FILE_TYPE = 'avi';
    public static readonly APK_FILE_TYPE = 'apk';
    public static readonly OLIC_FILE_TYPE = 'olic';
    public static readonly WMV_FILE_TYPE = 'wmv';
    public static readonly AUDIO_FILE_TYPE = 'audio';
    public static readonly VIDEO_FILE_TYPE = 'video';
    public static readonly RSS_FILE_TYPES = 'text/plain, application/rss+xml, text/xml';
    public static readonly APPLICATION_JSON_MIME_TYPE = 'application/json';
    public static readonly THE_NAME_EXISTS_ERROR = 'The name already exists.';
    public static readonly EXE_FILE_TYPE = 'exe';
    public static readonly DOCX_FILE_TYPE = 'docx';
    public static readonly PPT_FILE_TYPE = 'ppt';
    public static readonly PPTX_FILE_TYPE = 'pptx';
    public static readonly SVG_FILE_TYPE = 'svg';
    public static readonly JPG_FILE_TYPE = 'jpg';
    public static readonly PNG_FILE_TYPE = 'png';
    public static readonly XLSX_FILE_TYPE = 'xlsx';
    public static readonly MP4_FILE_TYPE = 'mp4';
    public static readonly WEBP_FILE_TYPE = 'webp';
    public static readonly WEBM_FILE_TYPE = 'webm';
    public static readonly VIDEO_SOURCE_TYPE = 'video/mp4';
    public static readonly CONTENT_PREVIEW_FILE_TYPES_REGULAR = /\.(jpg|png|webp|mp4|avi|webm|webp)$/i;
    public static readonly CONTENT_PREVIEW_VIDEO_FILE_TYPES_REGULAR = /\.(mp4|avi|webm|wmv|mov)$/i;
    public static readonly PPT_FILE_TYPES_REGULAR = /\.(ppt|pptx|pps)$/i;
    public static readonly PDF_FILE_TYPES_REGULAR = /\.(pdf)$/i;
    public static readonly DEVICE_CONNECTED_ERROR = 'Device already connected';
    public static readonly DEFAULT_PASSWORD_EXPIRATION_DAYS = 60;

    public static readonly PORTRAIT_VIEW = 'Portrait';
    public static readonly COLUMN_VIEW = 'Column';
    public static readonly CENTERED = 'Centered';
    public static readonly FOUR_MONITORS_OPTION = 'Four_Monitors__3';
    public static readonly FIVE_MONITORS_1_ROW_REST_COLUMN_OPTION = 'Five_Monitors_1_Row_Rest_Column__4';
    public static readonly FIVE_MONITORS_5_COLUMN_OPTION = 'Five_Monitors_5_Column__5';
    public static readonly FIVE_MONITORS_1_2_COLUMN_3_ROW_4_5_COLUMN_OPTION = 'Five_Monitors_1_2_Column_3_Row_4_5_Column_Centered__14';
    public static readonly SIX_MONITORS_OPTION = 'Six_Monitors__6';
    public static readonly NINE_MONITORS_OPTION = 'Nine_Monitors__13';
    public static readonly TWO_MONITORS_ROW_UNEQUAL_OPTION = 'Two_Monitors_Row_Unequal__10';
    public static readonly TWO_MONITORS_ROW_UNEQUAL_REVERSED_OPTION = 'Two_Monitors_Row_Unequal_Reversed__9';
    public static readonly TREE_MONITORS_1_ROW_2_3_COLUMN_OPTION = 'Tree_Monitors_1_Row_2_3_Column__11';
    public static readonly TREE_MONITORS_1_2_COLUMN_3_ROW_OPTION = 'Tree_Monitors_1_2_Column_3_Row__12';
    public static readonly MCL_MODE_ID_DELIMITER = '__';

    public static readonly PDF_FILE_TYPE = 'pdf';
    public static readonly WALL_FEATURE_NAME = 'wall';

    public static readonly DEFAULT_MONITOR_HEIGHT = 180;
    public static readonly MONITOR_HEIGHT_TO_WIDTH_PROPORTION = 0.7;
    public static readonly STYLE_PROPERTY_UNSET = 'unset';

    public static readonly MAT_CLASS_NAME_STARTS = 'mat-';
    public static readonly BODY_TAG_NAME = 'BODY';
    public static readonly SELECTED_FULL_SCREEN_CLASS_NAME = 'selected-full-screen';
    public static readonly CHROME_LAUNCHER_TITLE_PREFIX = 'chromelauncher';
    public static readonly CHROME_LAUNCHER_EXECUTABLE_NAME = 'ChromeLauncher.exe';
    public static readonly CHROME_LAUNCHER_ID = 2;
    public static readonly POWER_POINT_LAUNCHER_TITLE_PREFIX = 'powerpointlauncher';
    public static readonly VLC_LAUNCHER_TITLE_PREFIX = 'vlc';
    public static readonly MAWI_SERVER_IS_NO_RUNNING_ERROR_MESSAGE = 'MAWi service is not running';

    public static readonly LICENSE_REQUEST_FILE_NAME = 'LicenseRequest.xml';
    public static readonly LICENSE_URL_NAME = 'License';
    public static readonly UPDATE_CLIENT_FILE_PATH = '';

    public static readonly MAWI_REPEAT_BUTTON_TOOLTIP_MESSAGE = `The Repeat option is available only when there is a single item in the playlist. \n When checked, it will re-open the application in this playlist every given time in the Set Duration field. \n Mainly used to refresh the content of a URL or other file types that require to refresh their content. `;
    public static readonly DCT_URL_PATH = 'Displays-Configuration-Tool';

    public static readonly ALL_LOCATIONS_TITLE = 'All locations';

    public static readonly MODAL_WINDOW_WIDTH = '1000px';
    public static readonly TWO_FACTOR_AUTH_MODAL_WINDOW_WIDTH = '900px';
    public static readonly CONFIRM_PLAYLIST_TYPE_CHANGE_MODAL_WINDOW_WIDTH = '800px';
    public static readonly SELECT_OPTION_WINDOW_WIDTH = '380px';
    public static readonly RSS_SETTINGS_MODAL_WINDOW_WIDTH = '800px';
    public static readonly TIMER_SETTINGS_MODAL_WINDOW_WIDTH = '800px';
    public static readonly MANAGE_SYSTEM_MODAL_WINDOW_WIDTH = '800px';
    public static readonly ANDROID_CONNECTION_MODAL_WINDOW_WIDTH = '300px';
    public static readonly API_TOKEN_MODAL_WINDOW_WIDTH = '600px';
    public static readonly MCL_BORDERS_MODAL_WINDOW_WIDTH = '600px';

    public static readonly INVALID_DATE = 'Invalid Date';
    public static readonly DEFAULT_DATE_TIME_FORMAT = 'dd/MM/yyyy';
    public static readonly DEFAULT_MACHINE_DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm:ss';
    public static readonly AUDIO_FILE_DATE_TIME_FORMAT = 'HH:mm:ss';
    public static readonly PERMANENT_LICENSE_TYPE = 'Never';
    public static readonly EMAIL_VALIDATION_REGULAR = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    public static readonly DATE_PICKER_REGULAR = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;
    public static readonly DATE_MACHINE_REGULAR = /^(0[1-9]|[12][0-9]|3[01])[- \/.](0[1-9]|1[012])[- \/.](19|20)\d\d/;
    public static readonly PASSWORD_REGULAR = /^(?=.*[a-zA-Z])(?=.*\d)/;
    public static readonly IP_ADDRESS_REGULAR = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    public static readonly VALID_NUMBERS_REGULAR = /^[0-9]*$/;
    public static readonly ZERO_NUMBERS_REGULAR = /^0+/;
    public static readonly YOUTUBE_VIDEO_REGULAR = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/;
    public static readonly IMAGE_FORMAT_REGULAR = /image-*/;
    public static readonly VIDEO_FORMAT_REGULAR = /video-*/;
    public static readonly URL_REGULAR = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
    public static readonly LAST_SLASH_IN_STRING_REGULAR = /\/$/;
    public static readonly NEW_LINE_IN_STRING_REGULAR = /\\n/g;
    public static readonly NEW_LINE_CHARACTER = '\n';
    public static readonly NEW_LINE_REGULAR = /\n/g;
    public static readonly PPTX_TRANSFORMED_SLIDE_REGULAR = /-Slide-\d+/;
    public static readonly NEW_LINE_IN_STRING_CHARACTER = '\\n';
    public static readonly FULL_SCREEN_ENABLED_LAUNCHERS = ['chrome.exe', 'iexplorer.exe'];
    public static readonly FIT_SCREEN_ENABLED_LAUNCHERS = ['VLC media player'];
    public static readonly ANGULAR_MATERIAL_ICONS_PATH = '/assets/icons/angular-material-icons/';
    public static readonly LAUNCHERS_ICONS_PATH = '/assets/icons/launcher-images/';
    public static readonly FILE_TYPES_ICONS_PATH = '/assets/img/file-types/';
    public static readonly PLAYLIST_ITEM_ICONS_PATH = '/assets/icons/dashboard/playlist-item-dialog/';
    public static readonly LAUNCHER_FEATURE_ENABLED = '1';
    public static readonly LAUNCHER_FEATURE_DISABLED = '0';
    public static readonly TIMELINE_PLAYLIST_ICON_PATH = '<img src="/assets/icons/dashboard/playlist.png" />';
    public static readonly TAG_COLOR_PROPERTY = 'Color';
    public static readonly COLOR_PICKER_PRESET_COLORS = ['#ff0000', '#ffa500', '#ffff00', '#008000', '#0000ff', '#ffffff'];

    public static readonly CONTENT_TYPE_APPLICATION_ZIP = 'application/zip';
    public static readonly ANDROID_CONNECTION_TIMEOUT = 60000;

    public static readonly RSS_TICKER_ITEM_TITLE = 'RSS/Ticker';
    public static readonly RSS_TICKER_DEFAULT_TEXT_COLOR = '#ffffff';
    public static readonly RSS_TICKER_DEFAULT_BACKGROUND_COLOR = '#ff0000';
    public static readonly RSS_TICKER_DEFAULT_SCROLL_SPEED = 4;
    public static readonly RSS_TICKER_DEFAULT_TEXT_SIZE = 5;
    public static readonly RSS_TICKER_DEFAULT_MAX_ARTICLE_AGE = 0;
    public static readonly RSS_TICKER__DEFAULT_POSITION_Y = 0;
    public static readonly RSS_INPUT_PLACEHOLDER = 'http:// ; D:\\feed.rss ; text message';
    public static readonly RSS_CONFIGS_BLOCK_HEIGHT = 13;
    public static readonly RSS_CONFIGS_MONITOR_HEIGHT = 90;

    public static readonly TIMER_ITEM_TITLE = 'Timer';
    public static readonly CLOCK_ITEM_TITLE = 'Clock';
    public static readonly TIMER_DEFAULT_TEXT_COLOR = '#ffffff';
    public static readonly TIMER_DEFAULT_BACKGROUND_COLOR = '#ff0000';
    public static readonly TIMER_DEFAULT_POSITION = 0;
    public static readonly TIMER_DEFAULT_WIDTH = 20;
    public static readonly TIMER_MIN_WIDTH = 15;

    public static readonly MACHINE_CATEGORY_DEFAULT_BACKGROUND_COLOR = '#8dff00';
    public static readonly MACHINE_UNCATEGORIZED_BACKGROUND_COLOR = '#f0f8ff';
    public static readonly MACHINE_UNCATEGORIZED_ID = 0;
    public static readonly MACHINE_UNCATEGORIZED_NAME = 'Uncategorized';
    public static readonly MACHINE_ALL_CATEGORIES_NAME = 'All categories';

    public static readonly MACHINE_PHYSICAL_ADDRESS_PROPERTY = 'PhysicalAddress';

    public static readonly MACHINE_UNCATEGORIZED_CATEGORY: MachineCategory = {
      Id: null,
      Name: this.MACHINE_UNCATEGORIZED_NAME,
      Description: null,
      Color: this.MACHINE_UNCATEGORIZED_BACKGROUND_COLOR,
      Machines: []
    };

    public static readonly ASC_SORT_DIRECTION = 'ASC';
    public static readonly CONTENT_PREVIEW_TIMEOUT = 3000;
    public static readonly CONTENT_PREVIEW_DELAY_TIMEOUT = 300;
    public static readonly MCL_BORDER_DISABLED_WIDTH = 0;
    public static readonly MCL_BORDER_MIN_WIDTH = 1;
    public static readonly MCL_BORDER_DEFAULT_BACKGROUND_COLOR = '#28bd8b';

    public static readonly SCREENS_PER_PAGE = 'screensPerPage';
    public static readonly SCREENS_PER_PAGE_DEFAULT_VALUE = 10;
    public static readonly SELECTED_PAGE_INDEX_DEFAULT_VALUE = 0;
    public static readonly PAGE_SIZE_OPTIONS = [5, 10, 25];

    public static readonly CUSTOM_TIMER_MAX_HOURS = '23';
    public static readonly CUSTOM_TIMER_MAX_MINUTES = '59';
    public static readonly TIMER_HOURS_INPUT = 'hours';
    public static readonly TIMER_MINUTES_INPUT = 'minutes';
    public static readonly TIMER_SECONDS_INPUT = 'seconds';

    public static readonly FULL_SCREEN_TITLE = 'Full Screen';
    public static readonly FULL_SCREEN_DEFAULT_HANDLE = 0;
    public static readonly BASE_64_IMAGE_FORMAT = 'data:image/png;base64';

    public static readonly SCREEN_CACHE_CHANGED_DELAY = 7000;

    public static readonly SHARE_CONTENT_PLAYLIST_TITLE = 'Share Screen -';

    public static readonly FULL_SCREEN_ROUTE_PARAMS = {
      ID: 'id',
      HANDLE: 'handle',
      LABLE: 'label',
      RESOLUTION: 'resolution',
      REFRESH_RATE: 'refreshRate'
    } as const;

    public static readonly FULL_SCREEN_ROUTE = 'Screen';

    public static readonly FULL_SCREEN_PATH = [
      AppConstants.FULL_SCREEN_ROUTE,
      `:${AppConstants.FULL_SCREEN_ROUTE_PARAMS.ID}`,
      `:${AppConstants.FULL_SCREEN_ROUTE_PARAMS.HANDLE}`,
      `:${AppConstants.FULL_SCREEN_ROUTE_PARAMS.LABLE}`,
      `:${AppConstants.FULL_SCREEN_ROUTE_PARAMS.RESOLUTION}`,
      `:${AppConstants.FULL_SCREEN_ROUTE_PARAMS.REFRESH_RATE}`,
    ].join('/');

    public static FILE_UPLOADING_DIALOG_WINDOW_CONFIG: MatDialogConfig = {
        minHeight: '415px',
        width: '800px',
        disableClose: true
    };

    public static readonly RSS_SETTINGS_DIALOG_WINDOW_CONFIG: MatDialogConfig = {
      panelClass: 'custom-rss-modalbox',
      width: AppConstants.RSS_SETTINGS_MODAL_WINDOW_WIDTH,
      restoreFocus: false,
      autoFocus: false,
      disableClose: true
    };

    public static readonly TIMER_SETTINGS_DIALOG_WINDOW_CONFIG: MatDialogConfig = {
      panelClass: 'custom-rss-modalbox',
      width: AppConstants.TIMER_SETTINGS_MODAL_WINDOW_WIDTH,
      restoreFocus: false,
      autoFocus: false,
      disableClose: true
    };

    public static readonly MANAGE_SYSTEM_DIALOG_WINDOW_CONFIG: MatDialogConfig = {
      panelClass: 'custom-rss-modalbox',
      width: AppConstants.MANAGE_SYSTEM_MODAL_WINDOW_WIDTH,
      restoreFocus: false,
      autoFocus: false,
      disableClose: true
    }
    public static readonly MLC_BORDERS_DIALOG_WINDOW_CONFIG: MatDialogConfig = {
      panelClass: 'custom-rss-modalbox',
      width: AppConstants.MCL_BORDERS_MODAL_WINDOW_WIDTH,
      restoreFocus: false,
      autoFocus: false,
      disableClose: true
    };

    public static readonly LEGAL_CONSENT_DIALOG_WINDOW_CONFIG: MatDialogConfig = {
      width: AppConstants.RSS_SETTINGS_MODAL_WINDOW_WIDTH,
      restoreFocus: false,
      disableClose: true
    };
    public static readonly LEGAL_CONSENT_DEFAULT_TITLE = 'MAWi Software End User Legal Consent Agreement';
    public static readonly LEGAL_CONSENT_DEFAULT_TEXT = `By using the MAWi software provided by your organization, you agree to the terms in this Legal Consent Agreement. If you do not agree, discontinue use immediately.\n\n1.Acceptance of Terms\nBy using the MAWi software, you confirm that you have read, understood, and agree to comply with this agreement between you and the organization operating the software.\n\n2.Purpose of Use\nThe software is for business purposes within your organization, and your use must follow all organizational policies.\n\n3.Data Collection and Privacy\nThe software may collect data about your usage and device to improve performance. Your organization will handle this data per its privacy policy.\n\n4.User Responsibilities\nUse the software according to your organization’s policies. Unauthorized access, modification, distribution, or use is prohibited and may result in disciplinary action.\n\n5.Security and Confidentiality\nMaintain the confidentiality of your login credentials. Report any unauthorized use or security breaches to your administration.\n\n6.Termination of Use\nYour access may be terminated at any time, with or without notice, for misuse, policy non-compliance, or at the end of your association with the organization.\n\n7.Disclaimer of Warranties\nThe software is provided "as is" without any warranties. The organization does not guarantee reliability or performance.\n\n8.Limitation of Liability\nThe organization is not liable for any damages arising from your use of the software, including data loss, revenue loss, or inability to use the software.\n\n9.Governing Law\nThis agreement is governed by the laws of your organization’s headquarters. Disputes will be resolved per the organization's policies.\n\n10.Contact Information\nFor questions, contact your organization's IT department or software administrator.\n\nAcknowledgment\nBy using the MAWi software, you acknowledge that you have read, understood, and agree to this Legal Consent Agreement. If you do not agree, discontinue use and notify your administration.`;

    public static readonly LEGAL_CONSENT_CONTENT_MAX_LENGTH = 2000;
    public static readonly LEGAL_CONSENT_CONTENT_TITLE_MAX_LENGTH = 256;

    public static readonly TOASTR_CONFIG = {
      timeOut: 0,
      extendedTimeOut: 0
    };

    public static readonly UPDATE_CLIENT_DIALOG_WINDOW_CONFIG: MatDialogConfig = {
      minWidth: '50vw'
    };

    public static readonly WINDOWS_UPDATE_CLIENT_TAB_INDEX = 0;
    public static readonly ANDROID_UPDATE_CLIENT_TAB_INDEX = 1;

    public static ICONS: any[] = [
        { name: 'alert', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'alert.svg' },
        { name: 'add', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'add.svg' },
        { name: 'add_circle', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'add_circle.svg' },
        { name: 'android', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'android.svg' },
        { name: 'android_tv', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'android_tv.svg' },
        { name: 'android_monitor', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'android_monitor.svg' },
        { name: 'arrow_back', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'arrow_back.svg' },
        { name: 'arrow_downward', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'arrow_downward.svg' },
        { name: 'arrow_down', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'arrow_down.svg' },
        { name: 'arrow_drop_down', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'arrow_drop_down.svg' },
        { name: 'arrow_forward', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'arrow_forward.svg' },
        { name: 'arrow_backward', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'arrow_backward.svg' },
        { name: 'arrow_upward', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'arrow_upward.svg' },
        { name: 'border_all', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'border_all.svg' },
        { name: 'border_color', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'border_color.svg' },
        { name: 'cancel', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'cancel.svg' },
        { name: 'cancel_circle', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'cancel_circle.svg' },
        { name: 'copy', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'copy.svg' },
        { name: 'content_copy', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'content_copy.svg' },
        { name: 'close', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'close.svg' },
        { name: 'clock', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'clock.svg' },
        { name: 'clear', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'clear.svg' },
        { name: 'delete', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'delete.svg' },
        { name: 'delete_outline', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'delete_outline.svg' },
        { name: 'desktop', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'desktop.svg' },
        { name: 'download_laptop', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'download_laptop.svg' },
        { name: 'edit', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'edit.svg' },
        { name: 'edit_small', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'edit_small.svg' },
        { name: 'expand_more', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'expand_more.svg' },
        { name: 'fast_forward', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'fast_forward.svg' },
        { name: 'fast_rewind', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'fast_rewind.svg' },
        { name: 'file', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'file.svg' },
        { name: 'filter_center_focus', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'filter_center_focus.svg' },
        { name: 'folder_data', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'folder_data.svg' },
        { name: 'full_screen', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'full_screen.svg' },
        { name: 'full_screen_mode', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'fullscreen.svg' },
        { name: 'info', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'info.svg' },
        { name: 'image', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'image.svg' },
        { name: 'full_screen_active', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'full_screen_active.svg' },
        { name: 'grid_on', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'grid_on.svg' },
        { name: 'grid_off', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'grid_off.svg' },
        { name: 'help_outline', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'help_outline.svg' },
        { name: 'rocket_launch', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'rocket_launch.svg' },
        { name: 'key_on', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'key_on.svg' },
        { name: 'key_off', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'key_off.svg' },
        { name: 'list', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'list.svg' },
        { name: 'list_active', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'list_active.svg' },
        { name: 'maintenance', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'maintenance.svg' },
        { name: 'menu', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'menu.svg' },
        { name: 'menu_thick', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'menu_thick.svg' },
        { name: 'monitor', path: '/assets/icons/dashboard/television.svg' },
        { name: 'palette', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'palette.svg' },
        { name: 'pin_white', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'pin_white.svg' },
        { name: 'pin_black', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'pin_black.svg' },
        { name: 'picture_in_picture', path: AppConstants.PLAYLIST_ITEM_ICONS_PATH + 'picture_in_picture.svg' },
        { name: 'play_arrow', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'play_arrow.svg' },
        { name: 'play_circle', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'play_circle.svg' },
        { name: 'playlist_play', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'playlist_play.svg' },
        { name: 'priority_high', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'priority_high.svg' },
        { name: 'priority_high_small', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'priority_high_small.svg' },
        { name: 'remote-control', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'remote-control.svg' },
        { name: 'round_cancel', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'round_cancel.svg' },
        { name: 'round_check', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'round_check.svg' },
        { name: 'redo', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'redo.svg' },
        { name: 'refresh', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'refresh.svg' },
        { name: 'replay', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'replay.svg' },
        { name: 'rss', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'rss.svg' },
        { name: 'rss_file', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'rss_file.svg' },
        { name: 'save', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'save.svg' },
        { name: 'search', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'search.svg' },
        { name: 'settings', path: '/assets/icons/dashboard/bottom-menu/settings.svg' },
        { name: 'setting', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'settings.svg' },
        { name: 'schedule', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'schedule.svg' },
        { name: 'sort', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'sort.svg' },
        { name: 'stop', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'stop.svg' },
        { name: 'splitscreen_add', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'splitscreen_add.svg' },
        { name: 'tag-icon', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'tag-icon.svg' },
        { name: 'today', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'today.svg' },
        { name: 'timer', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'timer.svg' },
        { name: 'view_comfy', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'view_comfy.svg' },
        { name: 'view_comfy_active', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'view_comfy_active.svg' },
        { name: 'view_comfy_small', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'view_comfy_small.svg' },
        { name: 'view_comfy_small_active', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'view_comfy_small_active.svg' },
        { name: 'visibility', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'visibility.svg' },
        { name: 'visibility_off', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'visibility_off.svg' },
        { name: 'bottom-menu-settings', path: '/assets/icons/dashboard/bottom-menu/settings.svg' },
        { name: 'undo', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'undo.svg' },
        { name: 'update_duration', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'update_duration.svg' },
        { name: 'upgrade', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'upgrade.svg' },
        { name: 'upload', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'upload.svg' },
        { name: 'url_small', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'url_small.svg' },
        { name: 'logo', path: '/assets/dds_logo.svg' },
        { name: 'zoom_in', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'zoom_in.svg' },
        { name: 'zoom_out', path: AppConstants.ANGULAR_MATERIAL_ICONS_PATH + 'zoom_out.svg' },
    ];
}
